import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { S as LabeledInputSig } from "ui-kit/components/labeled-input";
import type { S as ValidatedFieldSig } from "../validated-field.gts";

export interface S {
  Element: LabeledInputSig["Element"];
  Args: {
    propertyName: string;
    onChangesetUpdate?: (changeset: EmberChangeset) => void;
    changeset: EmberChangeset;
    filterValue?: (value: string) => string;
    dataTestInput?: string;
  } & Pick<ValidatedFieldSig["Args"], "errorClass"> &
    Pick<
      LabeledInputSig["Args"],
      | "labelName"
      | "isMandatory"
      | "dataTestInput"
      | "propertyName"
      | "placeholder"
      | "type"
      | "min"
      | "max"
      | "disabled"
      | "isReadOnly"
      | "step"
      | "pattern"
      | "formnovalidate"
      | "autocomplete"
      | "onFocusOut"
      | "onFocusIn"
      | "moreInformation"
      | "value"
    >;
  Blocks: { default: [] };
}

export default class ChangesetLabeledInputComponent extends Component<S> {
  onChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (this.args.filterValue) {
      target.value = this.args.filterValue(target.value);
    }

    this.args.changeset.set(this.args.propertyName, target.value);
    this.args.onChangesetUpdate?.(this.args.changeset);
  };
}
